import React from "react"
import { RouteObject } from "react-router-dom"
import SettingsPage from "../page/settings-page"
import AuthGuard from "../../../shared/auth/component/auth"

export const SettingRoute: RouteObject = {
  path: "/setting",
  element: (
    // <AuthGuard role={["super_admin"]}>
    <SettingsPage />
    // </AuthGuard>
  ),
}
